import { Link, useLocation } from 'react-router-dom';
import { usePOSStore } from '../stores/posStore';

export default function Navigation(): JSX.Element {
  const location = useLocation();
  const getCartItemCount = usePOSStore((state) => state.getCartItemCount);

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg">
      <div className="flex justify-around">
        <Link
          to="/"
          className={`flex-1 py-3 px-4 text-center text-sm font-medium transition-colors ${
            isActive('/')
              ? 'text-blue-600 border-t-2 border-blue-600'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <div>Products</div>
        </Link>
        <Link
          to="/cart"
          className={`flex-1 py-3 px-4 text-center text-sm font-medium transition-colors relative ${
            isActive('/cart')
              ? 'text-blue-600 border-t-2 border-blue-600'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <div>
            Cart
            {getCartItemCount() > 0 && (
              <span className="absolute top-1 right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {getCartItemCount()}
              </span>
            )}
          </div>
        </Link>
        <Link
          to="/checkout"
          className={`flex-1 py-3 px-4 text-center text-sm font-medium transition-colors ${
            isActive('/checkout')
              ? 'text-blue-600 border-t-2 border-blue-600'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <div>Checkout</div>
        </Link>
      </div>
    </nav>
  );
}
